import Item from '../../../models/Item';
import AdaptiveTestModelBuilder from '../../../builder/AdaptiveTestModelBuilder';
import axios, { AxiosResponse } from 'axios';

class NavigationApiController {
  private readonly _sessionId: string;

  constructor(sessionId: string) {
    this._sessionId = sessionId;
  }

  getNextItem(currentItem: Item | null): Promise<Item | null> {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;
    return new Promise<Item | null>((resolve, reject) => {
      const itemIdentifier: string = currentItem !== null ? currentItem.identifier : '';
      const state: string = currentItem !== null ? currentItem.state : '';
      that
        .postData<Map<string, never>>(
          '<Adaptive Endpoint>',
          `{"sessionID":"${that._sessionId}", "itemIdentifier":"${itemIdentifier}", "state":${JSON.stringify(state)}}`
        )
        .then((responseData) => {
          resolve(AdaptiveTestModelBuilder.build(responseData));
        })
        .catch((error) => reject(error));
    });
  }

  private async postData<T = never>(path, requestBody): Promise<T> {
    const response: AxiosResponse = await axios.post<T>(path, requestBody);

    return response.data;
  }
}

export default NavigationApiController;
